import { GraphModel } from '../graph/graph.model';
import { z } from 'zod/v3';
import { ok } from 'neverthrow';
import { ApplicableContext } from '../actions/framework';
import { BaseAction } from '../actions/framework';
import { GRAPH_ACTION_GROUP } from '../dataset/actions/constants';
import { Routes } from '../routes';

type Params = {};

export class NewAgentAction extends BaseAction<Params> {
  title = 'New Agent';
  description = 'Opens a new agent editor';
  inputSchema = z.object({});
  group = GRAPH_ACTION_GROUP;
  icon = 'sparkles';

  constructor(
    private readonly navigator: {
      push: (opts: {
        route: string;
        title?: string;
        params: Record<string, string | undefined>;
      }) => void;
    }
  ) {
    super();
  }

  applicable(context: ApplicableContext): boolean {
    return context.isInScope(GraphModel);
  }

  async execute(_: z.infer<typeof this.inputSchema>) {
    this.navigator.push({
      route: Routes.agent.newAgent().toString(),
      params: {},
    });

    return ok({});
  }
}
